"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
var errorUtils_1 = require("spry-react/utils/errorUtils");
var knockoutComponent_1 = require("spry-react/Knockout/knockoutComponent");
var labeled_1 = require("spry-react/Label/labeled");
var lockToggle_1 = require("spry-react/Label/lockToggle");
require("../Warnings/warning.less");
var PhoneField = /** @class */ (function (_super) {
    __extends(PhoneField, _super);
    function PhoneField(props) {
        var _this = _super.call(this, props) || this;
        _this.onPhoneChange = function (value) {
            if (_this.isUpdatingKo) {
                return;
            }
            _this.isUpdatingReact = true;
            _this.props.onPhoneChange({
                countryCode: value.countryCode(),
                areaCode: value.areaCode(),
                number: value.number(),
                extension: value.extension(),
            });
            _this.isUpdatingReact = false;
        };
        _this.onPhoneComponentChange = function (value) {
            if (_this.isUpdatingKo) {
                return;
            }
            _this.isUpdatingReact = true;
            _this.props.onPhoneChange({
                countryCode: _this.vm.value().countryCode(),
                areaCode: _this.vm.value().areaCode(),
                number: _this.vm.value().number(),
                extension: _this.vm.value().extension(),
            });
            _this.isUpdatingReact = false;
        };
        _this.vm = {
            id: ko.observable(props.id),
            value: ko.observable({
                countryCode: ko.observable(props.phone.countryCode),
                areaCode: ko.observable(props.phone.areaCode),
                number: ko.observable(props.phone.number),
                extension: ko.observable(props.phone.extension)
            }),
            isRequired: ko.observable(!!props.required),
            isCountryCodeRequired: ko.observable(!!props.isCountryCodeRequired),
            isAreaCodeRequired: ko.observable(!!props.isAreaCodeRequired),
            isNumberRequired: ko.observable(props.isNumberRequired === undefined ? true : props.isNumberRequired),
            isExtensionRequired: ko.observable(!!props.isExtensionRequired),
            enable: ko.observable(!props.disabled),
            errors: ko.observable(_this.getErrorsFromProps(props)),
            title: ko.observable(props.title),
            className: ko.observable(props.className)
        };
        _this.subscriptions = [];
        _this.subscriptions.push(_this.vm.value.subscribe(_this.onPhoneChange));
        _this.subscriptions.push(_this.vm.value().countryCode.subscribe(_this.onPhoneComponentChange));
        _this.subscriptions.push(_this.vm.value().areaCode.subscribe(_this.onPhoneComponentChange));
        _this.subscriptions.push(_this.vm.value().number.subscribe(_this.onPhoneComponentChange));
        _this.subscriptions.push(_this.vm.value().extension.subscribe(_this.onPhoneComponentChange));
        return _this;
    }
    PhoneField.prototype.componentWillReceiveProps = function (nextProps) {
        if (!PhoneField.areSameErrors(this.props.errorMessages, nextProps.errorMessages)) {
            this.vm.errors(this.getErrorsFromProps(nextProps));
        }
        if (this.isUpdatingReact) {
            return;
        }
        if (this.props.phone !== nextProps.phone) {
            if (this.props.phone.countryCode !== nextProps.phone.countryCode
                || this.props.phone.areaCode !== nextProps.phone.areaCode
                || this.props.phone.number !== nextProps.phone.number
                || this.props.phone.extension !== nextProps.phone.extension) {
                this.isUpdatingKo = true;
                this.vm.value().countryCode(nextProps.phone.countryCode);
                this.vm.value().areaCode(nextProps.phone.areaCode);
                this.vm.value().number(nextProps.phone.number);
                this.vm.value().extension(nextProps.phone.extension);
                this.isUpdatingKo = false;
            }
        }
        this.vm.id(nextProps.id);
        this.vm.isRequired(!!nextProps.required);
        this.vm.isCountryCodeRequired(!!nextProps.isCountryCodeRequired);
        this.vm.isAreaCodeRequired(!!nextProps.isAreaCodeRequired);
        this.vm.isNumberRequired(nextProps.isNumberRequired === undefined ? true : nextProps.isNumberRequired);
        this.vm.isExtensionRequired(!!nextProps.isExtensionRequired);
        this.vm.enable(!nextProps.disabled);
        this.vm.title(nextProps.title || null);
        this.vm.className(nextProps.className || null);
    };
    PhoneField.areSameErrors = function (a, b) {
        if (a === b)
            return true;
        if (!a || !b)
            return false;
        if (a.countryCode !== b.countryCode
            || a.areaCode !== b.areaCode
            || a.number !== b.number
            || a.extension !== b.extension) {
            return false;
        }
        return true;
    };
    PhoneField.prototype.componentWillUnmount = function () {
        this.subscriptions.forEach(function (s) { return s.dispose(); });
    };
    PhoneField.prototype.getErrorsFromProps = function (props) {
        var _a, _b, _c, _d;
        var errors = {};
        // The dictionary keys need to be lower case for error messages to work for spry because
        // knockoutExtensions.js > ko.bindingHandlers.matrixPropertyError
        // will format the property to be lower case
        // with ko.bindingHandlers.matrixPropertyError.formatPropertyErrorName
        errors["phone.countrycode"] = errorUtils_1.toError((_a = props.errorMessages) === null || _a === void 0 ? void 0 : _a.countryCode).title;
        errors["phone.areacode"] = errorUtils_1.toError((_b = props.errorMessages) === null || _b === void 0 ? void 0 : _b.areaCode).title;
        errors["phone.number"] = errorUtils_1.toError((_c = props.errorMessages) === null || _c === void 0 ? void 0 : _c.number).title;
        errors["phone.extension"] = errorUtils_1.toError((_d = props.errorMessages) === null || _d === void 0 ? void 0 : _d.extension).title;
        return errors;
    };
    PhoneField.prototype.shouldComponentUpdate = function () {
        return false;
    };
    PhoneField.prototype.render = function () {
        var _a, _b, _c, _d;
        var content = React.createElement("div", { "data-bind": "component: { name: 'pb-phone-field', params: { value: value, isRequired: isRequired, isCountryCodeRequired: isCountryCodeRequired, isAreaCodeRequired: isAreaCodeRequired, isNumberRequired: isNumberRequired, isExtensionRequired: isExtensionRequired, title: title, enable: enable, errorPrefix: 'phone', className: className, id: id } }" });
        var focus = this.props.autoFocus ? '.phone-field-full-input' : '';
        var errors = this.props.errorMessages;
        var countryCodeOutput = errorUtils_1.toError((_a = errors) === null || _a === void 0 ? void 0 : _a.countryCode);
        var hasCountryCodeWarning = !countryCodeOutput.isValid && countryCodeOutput.allWarnings;
        var areaCodeOutput = errorUtils_1.toError((_b = errors) === null || _b === void 0 ? void 0 : _b.areaCode);
        var hasAreaCodeWarning = !areaCodeOutput.isValid && areaCodeOutput.allWarnings;
        var numberOutput = errorUtils_1.toError((_c = errors) === null || _c === void 0 ? void 0 : _c.number);
        var hasNumberWarning = !numberOutput.isValid && numberOutput.allWarnings;
        var extensionOutput = errorUtils_1.toError((_d = errors) === null || _d === void 0 ? void 0 : _d.extension);
        var hasExtensionWarning = !extensionOutput.isValid && extensionOutput.allWarnings;
        var hasWarning = hasCountryCodeWarning || hasAreaCodeWarning || hasNumberWarning || hasExtensionWarning;
        var hasError = (!countryCodeOutput.isValid && !countryCodeOutput.allWarnings)
            || (!areaCodeOutput.isValid && !areaCodeOutput.allWarnings)
            || (!numberOutput.isValid && !numberOutput.allWarnings)
            || (!extensionOutput.isValid && !extensionOutput.allWarnings);
        var classes = classNames({
            'input-validation-warning': hasWarning,
            'full-input-warning': !hasError && hasWarning,
            'country-code-warning': hasCountryCodeWarning,
            'area-code-warning': hasAreaCodeWarning,
            'phone-number-warning': hasNumberWarning,
            'extension-warning': hasExtensionWarning
        });
        return (React.createElement("div", { className: classes },
            React.createElement(knockoutComponent_1.KnockoutComponent, { content: content, vm: this.vm, focusElementSelector: focus })));
    };
    return PhoneField;
}(React.Component));
exports.PhoneField = PhoneField;
exports.LabeledPhoneField = labeled_1.labeled(PhoneField);
exports.LockTogglePhoneField = lockToggle_1.lockToggle(PhoneField);
